import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Params } from '@angular/router';
import { NgbModal, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';
import { SiteService } from 'app/_services/site.service';
import { SiteRequiredCompetencyDTO, SiteRequiredCompetencyService } from 'app/_services/site-required-competency.service';
import { EditSiteRequiredCompetenciesComponent } from './edit-site-required-competencies/edit-site-required-competencies.component';


@Component({
  selector: 'site-session-competencies',
  templateUrl: './site-session-competencies.component.html',
})
export class SiteSessionCompetenciesComponent implements OnInit {
  public selectedSite: any;
  private selectedSiteId: any;
  public requiredCompetencies: SiteRequiredCompetencyDTO[] = [];

  constructor(
    private siteService: SiteService,
    private siteRequiredCompetencyService: SiteRequiredCompetencyService,
    private modalService: NgbModal,
    activatedRoute: ActivatedRoute,
  ) {
    activatedRoute.params.subscribe((params: Params) => {
      this.selectedSiteId = params.id;
    });
  }

  ngOnInit() {
    this.getSelectedSite(this.selectedSiteId);
  }

  public getSelectedSite(id: string | number) {
    this.siteService.getSiteById(id).subscribe((data: any) => {
      this.selectedSite = data;
      this.loadRequiredCompetencies(+id);
    });
  }

  private loadRequiredCompetencies(siteId: number) {
    this.siteRequiredCompetencyService.getBySite(siteId).subscribe((items) => {
      this.requiredCompetencies = (items || []).sort((a, b) => {
        const typeCompare = (a.competencyType || '').localeCompare(b.competencyType || '');
        return typeCompare !== 0 ? typeCompare : (a.competencyTypeName || '').localeCompare(b.competencyTypeName || '');
      });
    });
  }

  public onEditCompetencies() {
    const modalOptions: NgbModalOptions = { centered: true};

    const modal = this.modalService.open(EditSiteRequiredCompetenciesComponent, modalOptions);
    modal.componentInstance.site = this.selectedSite;
    modal.componentInstance.existingRequired = this.requiredCompetencies;

    modal.result.then(result => {
      if (result === 'refresh') {
        this.loadRequiredCompetencies(+this.selectedSiteId);
      }
    }).catch(() => { /* modal dismissed */ });
  }
}
